var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25117 4.24824C3.64076 3.85866 4.27241 3.85866 4.66199 4.24824L19.7374 19.3236C20.127 19.7132 20.127 20.3449 19.7374 20.7344C19.3478 21.124 18.7161 21.124 18.3265 20.7344L3.25117 5.65906C2.86159 5.26948 2.86159 4.63783 3.25117 4.24824ZM18.8153 16.8624L16.1073 14.2627L7.84433 5.99974H13C14.1046 5.99974 15 6.89517 15 7.99974V10.7997L18.8153 7.13712C19.2602 6.70999 20 7.02532 20 7.64209V16.3574C20 16.9742 19.2602 17.2895 18.8153 16.8624ZM4.00532 7.85322L13.9254 17.7733C13.6487 17.9179 13.3339 17.9997 13 17.9997H6.00004C4.89547 17.9997 4.00004 17.1043 4.00004 15.9997V7.99974C4.00004 7.95047 4.00182 7.90161 4.00532 7.85322Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera_OFF.ee6fd0a2.svg";
export { ForwardRef as ReactComponent };